module.exports = __webpack_public_path__ + "static/media/car-top.11b8a962.svg";